let mask;

function zoomOnClick(el) {
  const url = el.dataset.zoomed;
  if (url) {
    if (el.nodeName === 'IMG') {
      const downloadable = el.dataset.downloadable || false;
      return zoomImage(url, downloadable);
    }
    if (el.nodeName === 'VIDEO') {
      return zoomVideo(url);
    }
  }
  zoom(el);
}

function zoom(el) {
  const preview_el = el.cloneNode(true);
  showInMediaOverlay(preview_el);
}

function zoomImage(url, downloadable) {
  const img = new Image();
  img.onload = () =>  {
    mask.classList.remove("loading");
  };
  showInMediaOverlay(img);      // must precede load() or we may not hit the onLoad
  if (downloadable) {
    showDownloadLink(url, downloadable);
  }
  img.src = url;
}

function zoomVideo(url) {
  const el = document.createElement('video');
  const src = document.createElement('source');
  showInMediaOverlay(el);
  el.appendChild(src)
  src.onLoad = () =>  mask.classList.remove("loading");
  src.src = url;
}

function hideMediaOverlay() {
  if (mask && mask.classList.contains('up')) {
    mask.classList.remove('up');
  }
}

function showInMediaOverlay(el) {
  lazyLoadMask();
  mask.querySelectorAll('img, video').forEach((el) => el.remove());
  mask.appendChild(el);
  mask.classList.add("loading");
  mask.classList.add('up');
}

function showDownloadLink(url, filename) {
  lazyLoadMask();
  const dl = document.createElement('a');
  dl.setAttribute('href', url);
  dl.setAttribute('download', filename || 'download');
  dl.classList.add('dl');
  const svg =  document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.classList.add('icon');
  const use =  document.createElementNS("http://www.w3.org/2000/svg", "use");
  use.setAttribute("href", "/lms-sprite.svg#download_button");
  const label = document.createElement('span');
  label.classList.add('label');
  label.innerText = "download";
  svg.appendChild(use);
  dl.appendChild(svg);
  dl.appendChild(label);
  mask.appendChild(dl);
}

function lazyLoadMask() {
  if (!mask) {
    mask = document.getElementById('zoom');
    mask.addEventListener('click', hideMediaOverlay, false);
  }
}


export {
  zoom,
  zoomImage,
  zoomOnClick,
  zoomVideo,
}